var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"additional"},[_c('div',{staticClass:"revolut-placeholder",style:({ backgroundImage: 'url(' + _vm.logo + ')' }),on:{"click":_vm.handleRevolutPayment}})])])}
var staticRenderFns = []

export { render, staticRenderFns }